import { Route, Routes } from 'react-router-dom';
import AdminDashboard from '../pages/admin/dashboard';
import AdminCompanies from '../pages/admin/companies/company';
import AdminAddCompany from '../pages/admin/companies/add_company';
import AdminEditCompany from '../pages/admin/companies/edit_company';
import AdminProtectedRoutes from '../utils/adminProtectedRoutes';
import AdminRoles from '../pages/admin/roles/roles';
import AdminStaffList from '../pages/admin/staff/staff';
import AddEditAdminStaff from '../pages/admin/staff/add_staff';

const AdminRoutes = () => {
  return (
    <Routes>  {/* Wrap your routes with <Routes> */}
      
        <Route path="/dashboard" element={<AdminDashboard />} />
        <Route path="/companies" element={<AdminCompanies />} />
        <Route path="/companies/add" element={<AdminAddCompany />} />
        <Route path="/companies/edit" element={<AdminEditCompany />} />
        <Route path='/roles' element={<AdminRoles/>}/>
        <Route path='/staff' element={<AdminStaffList/>}/>
        <Route path='/staff/add' element={<AddEditAdminStaff/>}/>
        <Route path='/staff/edit' element={<AddEditAdminStaff/>}/>
    </Routes>
  );
};

export default AdminRoutes;
